export enum LocalityType {
    WORKING = 'WORKING',
    PAST = 'PAST',
    PRIMARY = 'PRIMARY',
    SECONDARY = 'SECONDARY',
    RESIDENCE = 'RESIDENCE'
}